import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { PlatformTypes } from '@/types/gql.generated';

// The magic card's drawer activities. Deliberately narrower than the sync
// destinations: Outlook has no member, which is why only Google declares
// integration.hasModalWorkflowResume on its destination module (the
// post-modal-workflow reopen targets this store).
export enum Activity {
  AgendaHero = PlatformTypes.AgendaHero,
  GoogleCalendar = PlatformTypes.GoogleIntegration,
}

type State = {
  activity: Activity | null;
  open: (activity: Activity) => void;
  close: () => void;
  toggle: (activity: Activity) => void;
};

export const useMultiExportStore = createWithEqualityFn<State>()(
  (set) => ({
    activity: null,
    open: (activity) => set({ activity }),
    close: () => set({ activity: null }),
    toggle: (activity) =>
      set((state) => ({
        activity: activity === state.activity ? null : activity,
      })),
  }),
  shallow
);
